import { render, staticRenderFns } from "./post-card.vue?vue&type=template&id=aa28e78a&scoped=true"
import script from "./post-card.vue?vue&type=script&lang=js"
export * from "./post-card.vue?vue&type=script&lang=js"
import style0 from "./post-card.vue?vue&type=style&index=0&id=aa28e78a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa28e78a",
  null
  
)

export default component.exports